import { Box, Grid, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import React, { ReactNode } from 'react';
import { RoundedBackgroundIcon } from './roundedBackgroundIcon';

const useStyles = makeStyles(theme => ({
  disabled: {
    pointerEvents: 'none',
    backgroundColor: '#F1F2F3',
    '& .MuiPaper-root': {
      backgroundColor: 'transparent',
    },
  },
  paper: {
    border: `1px solid lightgray`,
    borderRadius: '16px !important',
    padding: theme.spacing(4),
  },
  title: {
    fontSize: '28px',
    color: 'black',
    fontWeight: 400,
  },
  subtitle: {
    fontSize: '14px',
    color: 'black',
    fontWeight: 400,
    marginTop: '16px',
  },
}));

interface OneToolCardProps {
  children?: ReactNode;
  disabled?: boolean;
  maxWidth?: any;
  icon?: ReactNode;
  title?: string;
  subtitle?: string;
  actions?: ReactNode;
  center?: boolean;
}

export const OneToolCard = (props: OneToolCardProps) => {
  const {
    children,
    disabled,
    maxWidth,
    icon,
    title,
    subtitle,
    actions,
    center,
  } = props;
  const classes = useStyles();

  return (
    <Box maxWidth={maxWidth} marginX={'auto'}>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <OneToolCardHeader
            icon={icon}
            title={title}
            subtitle={subtitle}
            actions={actions}
            center={center}
          />
        </Grid>
        <Grid item xs={12}>
          {children}
        </Grid>
      </Grid>
    </Box>
  );
};

export const OneToolCardBorder = ({
  children,
  disabled = false,
  className = undefined,
}) => {
  const classes = useStyles();

  return (
    <Paper
      className={clsx(classes.paper, disabled && classes.disabled, className)}
      elevation={0}
    >
      {children}
    </Paper>
  );
};

export const OneToolCardHeader = ({
  icon,
  title,
  subtitle,
  center,
  actions,
}) => {
  const classes = useStyles();

  return (
    <Box display="flex" alignItems="center">
      {!!icon && (
        <Box pr={2}>
          <RoundedBackgroundIcon Icon={icon} iconColor="#5E5E5E" />
        </Box>
      )}
      <Box display="flex" flexDirection={'column'} flex={1}>
        <Typography
          variant="h4"
          className={classes.title}
          style={{ textAlign: center ? 'center' : null }}
        >
          {title}
        </Typography>
        {!!subtitle && (
          <Typography
            variant="h4"
            className={classes.subtitle}
            style={{ textAlign: center ? 'center' : null }}
          >
            {subtitle}
          </Typography>
        )}
      </Box>
      {actions && <Box>{actions}</Box>}
    </Box>
  );
};
